import { render, staticRenderFns } from "./PleaseWait.vue?vue&type=template&id=6a9791fa&scoped=true&"
import script from "./PleaseWait.vue?vue&type=script&lang=js&"
export * from "./PleaseWait.vue?vue&type=script&lang=js&"
import style0 from "./PleaseWait.vue?vue&type=style&index=0&id=6a9791fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9791fa",
  null
  
)

export default component.exports